import { Rutas } from '@/constants/rutas';

export const NavigationAdminItems = [
    {
        title: 'Noticias Flash',
        shortTitle: 'Flash',
        path: Rutas.NOTICIAS_FLASH_ADMIN,
    },
    {
        title: 'Historias',
        shortTitle: 'Historias',
        path: Rutas.HISTORIAS,
    },
    {
        title: 'Once tipo',
        shortTitle: 'Once tipo',
        path: Rutas.ONCE_TIPO_ADMIN,
    },
    {
        title: 'Alineaciones probables',
        shortTitle: 'Alineaciones',
        path: Rutas.ADMIN_ALINEACIONES_PROBABLES,
    },
    {
        title: 'Administrador de Tierlists',
        shortTitle: 'Tierlists',
        path: Rutas.TIER_LIST_ADMIN,
    },
    {
        title: 'Configuración de Twitch',
        shortTitle: 'Twitch',
        path: Rutas.CONFIGURATION,
    },
    {
        title: 'Jugadores',
        shortTitle: 'Jugadores',
        path: Rutas.ADMINISTRADOR_JUGADORES,
    },
    {
        title: 'Imágenes',
        shortTitle: 'Imágenes',
        path: Rutas.ADMINISTRADOR_IMAGENES,
    },
    {
        title: 'Buscador de jugadores',
        shortTitle: 'Buscador',
        path: Rutas.BUSCADOR_JUGADORES,
    },
    {
        title: 'Cuentas de usuario',
        shortTitle: 'Cuentas',
        path: Rutas.ACCOUNTS,
    },
    {
        title: 'Administrador de partidos',
        shortTitle: 'Partidos',
        path: Rutas.ADMINISTRADOR_PARTIDOS,
    },
    {
        title: 'Configuraciones generales',
        shortTitle: 'Configuraciones',
        path: Rutas.ADMINISTRADOR_CONFIGURACIONES,
    },
    {
        title: 'Logs del sistema',
        shortTitle: 'Logs',
        path: Rutas.LOGS,
    },
    {
        title: 'Push Notifications',
        shortTitle: 'Push',
        path: Rutas.PUSH_NOTIFICATIONS,
    },
    {
        title: 'Predicción de mercado',
        path: Rutas.PREDICCION_DE_MERCADO,
        shortTitle: 'Predicción',
        id: 'prediccion-mercado',
    },
    {
        title: 'Ruleta Fantasy',
        path: Rutas.RULETA_FANTASY,
        shortTitle: 'Ruleta',
        id: 'ruleta-fantasy',
    },
];
